import { useMemo } from 'react';
import { useCurrentProject } from '@adsk/alloy-provider';
import { ASSIGNABLE_PRODUCTS_MAP } from '@common/constants';

export default () => {
  const project = useCurrentProject();

  const products = useMemo(() => project?.products || [], [project]);

  const assignableProducts = useMemo(
    () =>
      products
        .filter((product) => ASSIGNABLE_PRODUCTS_MAP[product.key])
        .sort(({ name: a }, { name: b }) => a.localeCompare(b)),
    [products]
  );

  const productsMapByKey = useMemo(
    () =>
      products.reduce(
        (map, product) =>
          ASSIGNABLE_PRODUCTS_MAP[product.key]
            ? { ...map, [product.key]: product }
            : map,
        {}
      ),
    [products]
  );

  return { data: assignableProducts, productsMapByKey, loading: !project };
};
